import PartnerSetupPage from "./partner-setup-page";

const PARTNER_SETUP_PAGE_PATH = "/integrations/:solutionSlug/setup";

export { PartnerSetupPage, PARTNER_SETUP_PAGE_PATH };
